import { createContext } from 'react'

import { DocKey } from 'src/docs/generated/docsManifest'

export type AskAiAboutDocParams = {
  docKey: DocKey
  prompt: string
  /** true: send the prompt immediately; false: prefill the chatbot input only */
  autoSend: boolean
}

// Provided by CmsChatbotProvider. Null outside the authenticated CMS shell,
// in which case the doc modal hides its Ask-AI section.
export type FieldDocChatContextType = { askAiAboutDoc: (params: AskAiAboutDocParams) => void } | null

export const fieldDocChatContext = createContext<FieldDocChatContextType>(null)
